import { apiGet } from './client';
import type {
  CourseDetail,
  CourseSummary,
  ExerciseSetView,
  ExerciseView,
  LearningItemView,
  LessonDetail,
  UnitDetail,
} from './content.types';

export const contentApi = {
  listCourses: () => apiGet<CourseSummary[]>('/courses'),
  getCourse: (courseId: string) => apiGet<CourseDetail>(`/courses/${courseId}`),
  getUnit: (unitId: string) => apiGet<UnitDetail>(`/units/${unitId}`),
  getUnitKanji: (unitId: string) => apiGet<LearningItemView[]>(`/units/${unitId}/kanji`),
  getLesson: (lessonId: string) => apiGet<LessonDetail>(`/lessons/${lessonId}`),
  listExercises: (lessonId: string) => apiGet<ExerciseView[]>(`/lessons/${lessonId}/exercises`),
  getExerciseSet: (unitId: string, setNumber: number) =>
    apiGet<ExerciseSetView>(`/units/${unitId}/exercise-sets/${setNumber}`),
};
